/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_News_List_Readmore1Inputs */

const ja_playdata_news_list_readmore1 = /** @type {(inputs: Playdata_News_List_Readmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read More`)
};

const en_playdata_news_list_readmore1 = /** @type {(inputs: Playdata_News_List_Readmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read More`)
};

/**
* | output |
* | --- |
* | "Read More" |
*
* @param {Playdata_News_List_Readmore1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_news_list_readmore1 = /** @type {((inputs?: Playdata_News_List_Readmore1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_News_List_Readmore1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_news_list_readmore1(inputs)
	return en_playdata_news_list_readmore1(inputs)
});
export { playdata_news_list_readmore1 as "playdata_news_list_readMore" }